import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import ConfirmationDialog from "../../components/Dialog/ConfirmationDialog";
import {
  ButtonGroup,
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../components/MaterialTypography";
import { BsFillPersonBadgeFill } from "react-icons/bs";
import MaterialBox from "../../components/MaterialBox";
import MaterialInput from "../../components/MaterialInput";
import MaterialButton from "../../components/MaterialButton";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext/AuthContextProvider";
import MaterialSelect from "../../components/MasterSelect";
import {
  allContact,
  AllRoleDetailsQuery,
  getContactdetail,
  getCustomerByMaster,
  getCustomerByUser,
  getLeadProspectByMaster,
  getLeadProspectByUser,
  getUserDetail,
  getVendorByMaster,
  getVendorByUser,
} from "../../lib/graphQL/graphQuery";
import BASEURL from "../Utils/Baseurl";
import request from "graphql-request";
import { AddContactMutation } from "../../lib/graphQL/graphMutation";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  deleteContactService,
  updateContactService,
} from "../../lib/appUtliz/ContactService";
import { useLoading } from "../../context/LodingContext";
import { useSuccess } from "../../context/SucccessContext";
import { useError } from "../../context/ErrorContext";
export default function AddContact() {
  const [roleData, setRoleData] = useState([]);
  const [organizationName, setOrganizationName] = useState([]);
  const [organizationSelect, setOrganizationSelct] = useState([]);

  const { circleLoading, setCirleLoading } = useLoading();
  const { successStatus, setSuccessStatus, setSucessTitle } = useSuccess();
  const { errorStatus, setErrorStatus , errormessage, setErrormessage } = useError();
  const [pendingLoading, setPendingLoading] = useState(false);

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
    done: "",
    back: "",
  });
  const [selectedData, setSelectedData] = useState([]);

  const [contactData, setContactData] = useState({
    // Contact Details
    firstName: "",
    lastName: "",
    organizationType: "",
    organizationId: "",
    organizationName: "",
    landLineNumber: "",
    role: "",
    whatsappNumber: "",
    dateOfBirth: "",
    age: "",
    contactNumber: "",
    secondaryNumber: "",
    mail: "",
    address1Line1: "",
    address1Line2: "",
    country1: "",
    state1: "",
    city1: "",
    zipCode1: "",

    // Contact Status
    firstNameStatus: "unchecked",
    lastNameStatus: "unchecked",
    organizationTypeStatus: "unchecked",
    organizationIdStatus: "unchecked",
    organizationNameStatus: "unchecked",
    landLineNumberStatus: "unchecked",
    roleStatus: "unchecked",
    whatsappNumberStatus: "unchecked",
    dateOfBirthStatus: "unchecked",
    ageStatus: "unchecked",
    contactNumberStatus: "unchecked",
    secondaryNumberStatus: "unchecked",
    mailStatus: "unchecked",
    address1Line1Status: "unchecked",
    address1Line2Status: "unchecked",
    country1Status: "unchecked",
    state1Status: "unchecked",
    city1Status: "unchecked",
    zipCode1Status: "unchecked",
  });
  const [organizationId, setOrganizationId] = useState("");
  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });
  const { currentUser } = useAuth();
  const isUser = currentUser?.role;

  const userid = currentUser?.id;
  const navigate = useNavigate();
  const params = useLocation();
  const id = params.search.slice(1);

  const leadName = "Prospect";
  const vendor = "Vendor";
  const customer = "Customer";

  const organizationOption = [
    { id: "1", value: "customer" },
    { id: "2", value: "vendor" },
    { id: "3", value: "Prospect" },
  ];

  useEffect(() => {
    if (id) {
      fetchUpdateValue();
    }
  }, [id]);

  const fetchUpdateValue = async () => {
    try {
      const res = await request(BASEURL, getContactdetail, {
        id: id,
      });

      const v = res.getContactdetail;
      setSelectedData(v);

      if (v.id == id) {
        setOrganizationId(v?.organizationId);
        setContactData({
          firstName: v.firstName,
          lastName: v.lastName,
          organizationType: {
            value: v.organizationType,
            label: v.organizationType,
          },
          organizationId: v.organizationId,
          organizationName: {
            value: v.organizationName,
            label: v.organizationName,
          },
          landLineNumber: v.landLineNumber,
          role: {
            value: v.role,
            label: v.role,
          },
          whatsappNumber: v.whatsappNumber,
          dateOfBirth: v.dateOfBirth,
          age: v?.age || "",
          contactNumber: v.contactNumber,
          secondaryNumber: v.secondaryNumber,
          mail: v.mailId,
          address1Line1: v.address1Line1,
          address1Line2: v.address1Line2,
          country1: v.country1,
          state1: v.state1,
          city1: v.city1,
          zipCode1: v.zipCode1,

          // Contact Status
          firstNameStatus: "success",
          lastNameStatus: "success",
          organizationTypeStatus: "success",
          organizationIdStatus: "success",
          organizationNameStatus: "success",
          landLineNumberStatus: "success",
          roleStatus: "success",
          whatsappNumberStatus: "success",
          dateOfBirthStatus: "success",
          ageStatus: "success",
          contactNumberStatus: "success",
          secondaryNumberStatus: "success",
          mailStatus: "success",
          address1Line1Status: "success",
          address1Line2Status: "success",
          country1Status: "success",
          state1Status: "success",
          city1Status: "success",
          zipCode1Status: "success",
        });
      }
    } catch (err) {}
  };
  useEffect(() => {
    setTogglePage({
      ...togglePage,
      view: params?.search !== "" ? true : false,
    });
  }, []);
  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  const handleContactDataChange = (event, selectEvent) => {
    let contactState = { ...contactData };
    if (event?.target === undefined && selectEvent) {
      switch (selectEvent.name) {
        case "role":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              contactState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              contactState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "organizationType":
          const organizationType = event?.label.toLowerCase();
          setOrganizationSelct(organizationType);

          if (organizationType == customer.toLowerCase()) {
            request(
              BASEURL,
              isUser.toLowerCase() === "manager" ||
                isUser.toLowerCase() === "superuser" ||
                isUser.toLowerCase() === "accounting manger"
                ? getCustomerByMaster
                : isUser.toLowerCase() === "employee"
                ? getCustomerByUser
                : "Data Not Found",
              { id: currentUser?.id }
            ).then((res) => {
              setOrganizationName(
                isUser.toLowerCase() === "manager" ||
                  isUser.toLowerCase() === "superuser" ||
                  isUser.toLowerCase() === "accounting manger"
                  ? res.getCustomerdetailByMaster
                  : isUser.toLowerCase() === "employee"
                  ? res.getCustomerdetailByUser
                  : []
              );
            });
          } else if (organizationType == vendor.toLowerCase()) {
            request(
              BASEURL,
              isUser.toLowerCase() == "manager" ||
                isUser.toLowerCase() == "superuser" ||
                isUser.toLowerCase() == "accounting manger"
                ? getVendorByMaster
                : isUser.toLowerCase() == "employee"
                ? getVendorByUser
                : "Data Not Found",
              { id: userid }
            )
              .then((res) => {
                setOrganizationName(
                  isUser.toLowerCase() == "manager" ||
                    isUser.toLowerCase() == "superuser" ||
                    isUser.toLowerCase() == "accounting manger"
                    ? res.getVendordetailByMaster
                    : isUser.toLowerCase() == "employee"
                    ? res.getVendordetailByUser
                    : []
                );
              })
              .catch((err) => console.error(err));
          } else if (organizationType == leadName.toLowerCase()) {
            request(
              
              BASEURL,
              isUser.toLowerCase() == "manager" ||
                isUser.toLowerCase() == "superuser" ||
                isUser.toLowerCase() == "accounting manger"
                ? getLeadProspectByMaster
                : isUser.toLowerCase() == "employee"
                ? getLeadProspectByUser
                : "Data Not Found",
              { id: currentUser?.id }
            ).then((res) => {
              setOrganizationName(
                isUser.toLowerCase() == "manager" ||
                  isUser.toLowerCase() == "superuser" ||
                  isUser.toLowerCase() == "accounting manger"
                  ? res.getLeadprospectDetailByMaster
                  : isUser.toLowerCase() == "employee"
                  ? res.getLeadprospectDetailByUser
                  : []
              );
            });
          }
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              contactState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
              contactState["organizationName"] = "";
              contactState["organizationNameStatus"] = "unchecked";
            } else {
              contactState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
              contactState["organizationName"] = "";
              contactState["organizationNameStatus"] = "unchecked";
            }
          }
          break;
        case "organizationName":
          const organizationId = event?.value;

          setOrganizationId(organizationId);

          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              contactState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              contactState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }
      contactState[selectEvent.name] = event;
    } else if (event) {
      switch (event.target.name) {
        case "firstName":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{2,20})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              contactState[event.target.name + "Status"] = "success";
            } else {
              contactState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "lastName":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{0,20})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              contactState[event.target.name + "Status"] = "success";
            } else {
              contactState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        // case "dateOfBirth":
        //   {
        //     const alphaNLenghthRegex = new RegExp(
        //       "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~]{10,150}$"
        //     );
        //     if (alphaNLenghthRegex.test(event.target.value?.trim())) {
        //       contactState[event.target.name + "Status"] = "success";
        //     } else {
        //       contactState[event.target.name + "Status"] =
        //         event.target.value === "" ? "unchecked" : "error";
        //     }
        //   }
        //   break;
        // case "age":
        case "dateOfBirth": {
          const dateRegex = new RegExp("^[0-9]{4}-[0-9]{2}-[0-9]{2}$");
          const dateValue = event.target.value?.trim();
      
          if (dateRegex.test(dateValue)) {
              const inputDate = new Date(dateValue);
              const today = new Date();
              const age = today.getFullYear() - inputDate.getFullYear();

              // Calculate if the age is at least 18, considering month/day
              const isOldEnough =
                (age > 18 && age < 150) ||
                (age === 18 &&
                  (today.getMonth() > inputDate.getMonth() ||
                    (today.getMonth() === inputDate.getMonth() &&
                      today.getDate() >= inputDate.getDate())));

              if (isOldEnough) {
                contactState[event.target.name + "Status"] = "success";
              } else {
                contactState[event.target.name + "Status"] = "error"; // Set to error if below 18
              }
      
              // Check if age is within the valid range (18 - 150)
              if (age >= 18 && age < 130) {
                  contactState.dateOfBirthStatus = "success";
                  contactState.ageStatus = "success";
                  contactState.age = age.toString(); // Automatically update the age field
              } else {
                  contactState.dateOfBirthStatus = "error";
                  contactState.ageStatus = "error";
                  contactState.age = "";
              }
          } else {
              contactState.dateOfBirthStatus = dateValue === "" ? "unchecked" : "error";
              contactState.ageStatus = "error";
              contactState.age = "";
          }
      }
      break;
      

          {
            const alphaNLenghthRegex = new RegExp("^([0-9 ]{1,2})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              contactState[event.target.name + "Status"] = "success";
            } else {
              contactState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "mail":
          {
            const alphaNLenghthRegex = new RegExp(
              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
            );
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              contactState[event.target.name + "Status"] = "success";
            } else {
              contactState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
          case "contactNumber":
            {
              const numberRegex = new RegExp("^\\d{1,15}$"); 
              if (numberRegex.test(event.target.value?.trim())) {
                contactState[event.target.name + "Status"] = "success";
              } else {
                contactState[event.target.name + "Status"] =
                  event.target.value === "" ? "unchecked" : "error";
              }
            }
            break;
          
        case "landLineNumber":
          {
            const alphaNLenghthRegex = new RegExp("^([0-9]{10})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              contactState[event.target.name + "Status"] = "success";
            } else {
              contactState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "whatsappNumber":
          {
            const alphaNLenghthRegex = new RegExp("^([0-9]{10})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              contactState[event.target.name + "Status"] = "success";
            } else {
              contactState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "secondaryNumber":
          {
            const alphaNLenghthRegex = new RegExp("^([0-9]{10})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              contactState[event.target.name + "Status"] = "success";
            } else {
              contactState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "address1Line1":
          {
            const alphaNLenghthRegex = new RegExp("^.{1,150}$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              contactState[event.target.name + "Status"] = "success";
            } else {
              contactState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "address1Line2":
          {
            const alphaNLenghthRegex = new RegExp("^.{1,150}$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              contactState[event.target.name + "Status"] = "success";
            } else {
              contactState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "country1":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,30})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              contactState[event.target.name + "Status"] = "success";
            } else {
              contactState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "state1":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,30})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              contactState[event.target.name + "Status"] = "success";
            } else {
              contactState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "city1":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,30})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              contactState[event.target.name + "Status"] = "success";
            } else {
              contactState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "zipCode1":
          {
            const alphaNLenghthRegex = new RegExp("^([ A-Za-z0-9]{6})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              contactState[event.target.name + "Status"] = "success";
            } else {
              contactState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }
      contactState[event.target.name] = event.target.value;
    }

    setContactData(contactState);
  };

  const fetchRoleData = () => {
    request(BASEURL, AllRoleDetailsQuery, { id: currentUser?.id }).then(
      (res) => {
        setRoleData(res.allRoleDetail);
      }
    );
  };
  useEffect(() => {
    fetchRoleData();
  }, []);

  useEffect(() => {
    setContactData({
      ...contactData,
      age: calculateAge(contactData.dateOfBirth),
    });
  }, [contactData.dateOfBirth]);

  const calculateAge = (dob) => {
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age.toString();
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      contactData.firstNameStatus === "success" &&
      (contactData.dateOfBirthStatus === "success" ||
        contactData.dateOfBirthStatus == "unchecked") &&
   
      contactData.organizationTypeStatus === "success" &&
      //   contactData.organizationNameStatus === "success" &&
      contactData.mailStatus === "success" &&
      contactData.contactNumberStatus === "success" 
      // contactData.address1Line1Status === "success" &&
      // contactData.country1Status === "success" &&
      // contactData.state1Status === "success" &&
      // contactData.city1Status === "success" &&
      // contactData.zipCode1Status === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handleAddContactData = async () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to submit your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        try {
          const response = await request(BASEURL, AddContactMutation, {
            id: currentUser?.id,
            firstName: contactData.firstName,
            lastName: contactData.lastName,
            organizationType: contactData.organizationType?.label,
            organizationId: organizationId,
            organizationName: contactData.organizationName?.label,
            landLineNumber: contactData.landLineNumber,
            role: contactData.role?.label || "",
            whatsappNumber: contactData.whatsappNumber,
            dateOfBirth: contactData.dateOfBirth,
            age: contactData.age,
            contactNumber: contactData.contactNumber,
            secondaryNumber: contactData.secondaryNumber,
            mail: contactData.mail,
            address1Line1: contactData.address1Line1,
            address1Line2: contactData.address1Line2,
            country1: contactData.country1,
            state1: contactData.state1,
            city1: contactData.city1,
            zipCode1: contactData.zipCode1,
          }).then((res) => console.error(res));

          setSuccessStatus(true);
          setSucessTitle("Contact Created");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/contact");
          }, 1000);
        } catch (error) {
          console.error(error?.response.errors[0].message, "jj");
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });

          setErrorStatus(true);
          setErrormessage(error?.response?.errors[0]?.message);
          setTimeout(() => {
            setErrorStatus(false);
          }, 1000);
        } finally {
          setCirleLoading(false);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const handleEditContactData = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to submit your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        const values = {
          firstName: contactData.firstName,
          lastName: contactData.lastName,
          organizationType: contactData.organizationType?.label,
          organizationId: organizationId,
          organizationName: contactData.organizationName?.label,
          landLineNumber: contactData.landLineNumber,
          role: contactData.role?.label,
          whatsappNumber: contactData.whatsappNumber,
          dateOfBirth: contactData.dateOfBirth,
          age: contactData.age,
          contactNumber: contactData.contactNumber,
          secondaryNumber: contactData.secondaryNumber,
          mailId: contactData.mail,
          address1Line1: contactData.address1Line1,
          address1Line2: contactData.address1Line2,
          country1: contactData.country1,
          state1: contactData.state1,
          city1: contactData.city1,
          zipCode1: contactData.zipCode1,
        };
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setCirleLoading(true);
        const{errormessage,updateStatus}= await updateContactService(values, id);
        setCirleLoading(false);
        if (updateStatus) {
          setSuccessStatus(true);
          setSucessTitle("Contact Updated");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/contact");
          }, 1000);
        } else {
          setErrorStatus(true);
          setErrormessage(errormessage)
          setTimeout(() => {
            setErrorStatus(false);
          }, 3000);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const handleDelteContactData = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your detail.",
      showCancel: true,
      showConfirm: true,

      onConfirm: async () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setPendingLoading(true);
        const delteStatus = await deleteContactService(id);
        setPendingLoading(false);
        if (delteStatus) {
          setSuccessStatus(true);
          setSucessTitle("Contact Deleted");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/contact");
          }, 1000);
        } else {
          setErrorStatus(true);
          setTimeout(() => {
            setErrorStatus(false);
          }, 1000);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const handleDiscardButton = () => {
    setTogglePage({
      view: true,
      edit: false,
    });

    setContactData({
      firstName: selectedData.firstName,
      lastName: selectedData.lastName,
      organizationType: {
        value: selectedData.organizationType,
        label: selectedData.organizationType,
      },
      organizationId: "",
      organizationName: {
        value: selectedData.organizationName,
        label: selectedData.organizationName,
      },
      landLineNumber: selectedData.landLineNumber,
      role: {
        value: selectedData.role,
        label: selectedData.role,
      },
      whatsappNumber: selectedData.whatsappNumber,
      dateOfBirth: selectedData.dateOfBirth,
      age: selectedData.age,
      contactNumber: selectedData.contactNumber,
      secondaryNumber: selectedData.secondaryNumber,
      mail: selectedData.mailId,
      address1Line1: selectedData.address1Line1,
      address1Line2: selectedData.address1Line2,
      country1: selectedData.country1,
      state1: selectedData.state1,
      city1: selectedData.city1,
      zipCode1: selectedData.zipCode1,

      // Contact Status
      firstNameStatus: "success",
      lastNameStatus: "success",
      organizationTypeStatus: "success",
      organizationIdStatus: "success",
      organizationNameStatus: "success",
      landLineNumberStatus: "success",
      roleStatus: "success",
      whatsappNumberStatus: "success",
      dateOfBirthStatus: "success",
      ageStatus: "success",
      contactNumberStatus: "success",
      secondaryNumberStatus: "success",
      mailStatus: "success",
      address1Line1Status: "success",
      address1Line2Status: "success",
      country1Status: "success",
      state1Status: "success",
      city1Status: "success",
      zipCode1Status: "success",
    });
  };
  const handleCancelContactData = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message:
        "The Entered Details will not be saved. Do you want to Cancel it?",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        // const delteStatus = await deleteBrandService(id);
        // if (delteStatus) {
        navigate("/contact");
        // } else if (!delteStatus) {
        // }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
          done={confirmationDialog.done}
          back={confirmationDialog.back}
        />
      )}
      <Card>
        <CardHeader
          title={
            <>
              {togglePage.view === true  ? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Contact Details
                    </MaterialTypography>
                  </Stack>
                  <ButtonGroup
                    variant="outlined"
                    aria-label="Loading button group"
                  >
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                       size="small"
                      onClick={toggleEdit}
                      startIcon={<EditIcon />}
                    >
                      Edit
                    </MaterialButton>
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                       size="small"
                      onClick={handleDelteContactData}
                      startIcon={<DeleteIcon />}
                    >
                      delete
                    </MaterialButton>
                  </ButtonGroup>
                </Stack>
              ) :togglePage.edit === true? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Edit Contact Details
                    </MaterialTypography>
                  
                  </Stack>
                  <MaterialButton
                      variant="gradient"
                      color="dark"
                      size="small"
                      onClick={toggleEdit}
                      startIcon={<EditIcon />}
                    >
                      Edit
                    </MaterialButton>
                </Stack>
              )
              : (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Add Contact Details
                    </MaterialTypography>
                  </Stack>
                </Stack>
              )}
            </>
          }
        />
        <CardContent sx={{ minHeight: "60vh" }}>
          <Stack direction="row" spacing={1} p={1} bgcolor={"#f5f5f5"}>
            <BsFillPersonBadgeFill style={{ fontSize: 20, color:'#460058' }} />
            <MaterialTypography
            sx={{color:'#460058',fontFamily:'Aptos'}}
              component="label"
              variant="body2"
              fontWeight="700"
            >
              Contact Information
            </MaterialTypography>
          </Stack>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    First Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="firstName"
                  size="small"
                  placeholder="eg. Ajith Kumar"
                  value={contactData.firstName}
                  onChange={handleContactDataChange}
                  error={contactData.firstNameStatus === "error" ? true : false}
                  success={
                    contactData.firstNameStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {contactData.firstNameStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      User Name should be maximum 20 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Last Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="lastName"
                  size="small"
                  placeholder="eg. Kumar"
                  value={contactData.lastName}
                  onChange={handleContactDataChange}
                  error={contactData.lastNameStatus === "error" ? true : false}
                  disabled={togglePage?.view === true ? true : false}
                  success={
                    contactData.lastNameStatus === "success" ? true : false
                  }
                />
                {contactData.lastNameStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      User Last Name should be maximum 20 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Date Of Birth
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="dateOfBirth"
                  size="small"
                  type="date"
                  placeholder=""
                  value={contactData.dateOfBirth}
                  onChange={handleContactDataChange}
                  error={
                    contactData.dateOfBirthStatus === "error" ? true : false
                  }
                  success={
                    contactData.dateOfBirthStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {contactData.dateOfBirthStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter Valid Date of Birth
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Age 
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="age"
                  placeholder="Age"
                  size="small"
                  value={contactData.age}
                  onChange={handleContactDataChange}
                  error={contactData.ageStatus === "error" ? true : false}
                  disabled={togglePage?.view === true ? true : false}
                  success={contactData.ageStatus === "success" ? true : false}
                />
                {contactData.ageStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Please Enter Valid Age</FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Role
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="role"
                  size="small"
                  value={contactData.role}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleContactDataChange} //selectedValue, event
                  options={roleData?.map((value) => {
                    return {
                      value: value.role,
                      label: value.role,
                    };
                  })}
                  error={contactData.roleStatus === "error" ? true : false}
                  success={contactData.roleStatus === "success" ? true : false}
                  isClearable
                  isDisabled={togglePage?.view === true ? true : false}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Organization Type <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="organizationType"
                  size="small"
                  value={contactData.organizationType}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleContactDataChange} //selectedValue, event
                  options={organizationOption?.map((option) => {
                    return {
                      value: option.value,
                      label: option.value,
                    };
                  })}
                  isDisabled={togglePage?.view === true ? true : false}
                  error={
                    contactData.organizationTypeStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    contactData.organizationTypeStatus === "success"
                      ? true
                      : false
                  }
                  isClearable
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Organization Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="organizationName"
                  size="small"
                  value={contactData.organizationName}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleContactDataChange} //selectedValue, event
                  options={organizationName.map((value) => {
                    return {
                      value: value.id,
                      label:
                        organizationSelect == leadName.toLowerCase()
                          ? value.companyName

                          : value.legalName,
                    };
                  })}
                  isDisabled={togglePage?.view === true ? true : false}
                  error={
                    contactData.organizationNameStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    contactData.organizationNameStatus === "success"
                      ? true
                      : false
                  }
                  isClearable
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Email ID <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="mail"
                  size="small"
                  placeholder="eg. Admin@gmail.com"
                  value={contactData.mail}
                  onChange={handleContactDataChange}
                  error={contactData.mailStatus === "error" ? true : false}
                  disabled={togglePage?.view === true ? true : false}
                  success={contactData.mailStatus === "success" ? true : false}
                />
                {contactData.mailStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Enter Valid Email Address</FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Contact Number <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="contactNumber"
                  size="small"
                  placeholder="98401*****"
                  value={contactData.contactNumber}
                  onChange={handleContactDataChange}
                  disabled={togglePage?.view === true ? true : false}
                  error={
                    contactData.contactNumberStatus === "error" ? true : false
                  }
                  success={
                    contactData.contactNumberStatus === "success" ? true : false
                  }
                />
                {contactData.contactNumberStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter Valid Contact Number
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Landline Number
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="landLineNumber"
                  size="small"
                  placeholder="8401****"
                  value={contactData.landLineNumber}
                  onChange={handleContactDataChange}
                  disabled={togglePage?.view === true ? true : false}
                  error={
                    contactData.landLineNumberStatus === "error" ? true : false
                  }
                  success={
                    contactData.landLineNumberStatus === "success"
                      ? true
                      : false
                  }
                />
                {contactData.landLineNumberStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter Valid Land Line Number
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Whatsapp Number
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="whatsappNumber"
                  size="small"
                  placeholder="98401****"
                  value={contactData.whatsappNumber}
                  onChange={handleContactDataChange}
                  disabled={togglePage?.view === true ? true : false}
                  error={
                    contactData.whatsappNumberStatus === "error" ? true : false
                  }
                  success={
                    contactData.whatsappNumberStatus === "success"
                      ? true
                      : false
                  }
                />
                {contactData.whatsappNumberStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter Valid whatsapp Number
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Secondary Number
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="secondaryNumber"
                  size="small"
                  placeholder="98401*****"
                  value={contactData.secondaryNumber}
                  onChange={handleContactDataChange}
                  disabled={togglePage?.view === true ? true : false}
                  error={
                    contactData.secondaryNumberStatus === "error" ? true : false
                  }
                  success={
                    contactData.secondaryNumberStatus === "success"
                      ? true
                      : false
                  }
                />
                {contactData.secondaryNumberStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter Valid Secondary Number
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>

            </Grid>
          </MaterialBox>
          <MaterialBox
            mt={3}
            display="flex"
            justifyContent="center"
            alignItems="center"
            
          >
            {togglePage.edit === true ? (
              <>
                <MaterialButton
                  variant="gradient"
                  color="dark"
                  size="small"
                  onClick={handleDiscardButton}
                >
                  Discard
                </MaterialButton>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  size="small"
                  disabled={!checkAllFields()}
                  onClick={handleEditContactData}
                >
                  update
                </MaterialButton>
              </>
            ) : togglePage.view === false && togglePage.edit === false ? (
              <>
                
                <MaterialButton
                  variant="gradient"
                  color="dark"
                  size="small"
                  onClick={handleCancelContactData}
                >
                  Cancel
                </MaterialButton>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  size="small"
                  disabled={!checkAllFields()}
                  onClick={handleAddContactData}
                >
                  Submit
                </MaterialButton>
              </>
            ) : null}
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}
